var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-grid"},[_c('router-link',{staticClass:"btn btn-primary float-end btn-sm mb-1",attrs:{"to":_vm.extra.url}},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }